export default {"src":"/_next/static/media/hugeicons_electric-wire.25e204de.svg","height":54,"width":55,"blurWidth":0,"blurHeight":0};